import { Injectable, signal } from '@angular/core';

/**
 * Service to manage the global spinner (loading) state using Angular signals.
 * 
 * This is useful for controlling a shared loading indicator across the application,
 * such as when making API calls or performing background tasks.
 */
@Injectable({ providedIn: 'root' })
export class AppScrollableState {
  /**
   * Internal signal that holds the spinner's visibility state.
   * `true` indicates that the spinner is visible; `false` means it's hidden.
   */
  private appScrollable = signal(true);

  /**
   * Public getter for the loading signal. Components can subscribe to this signal
   * to reactively show or hide the spinner based on state changes.
   * 
   * @returns A reactive signal representing the spinner's visibility.
   */
  get scrollable() {
    return this.appScrollable;
  }
  
  makeScrollable(): void {
    this.appScrollable.set(true);
  }

  makeUnscrollable(): void {
    this.appScrollable.set(false);
  }

  /**
   * Sets the scrollable state.
   * @param value - The new scrollable state.
   */
  setScrollable(value: boolean): void {
    this.appScrollable.set(value);
  }
}
